
    import {
      getAllRequirements,
      createRequirement,
      createAllRequirements,
      updateRequirement,
      deleteRequirement
    } from "@/services/requirement";

    const state = {
      requirements: [],
      processed: false
    };

    const getters = {
      getRequirements(state) {
        return state.requirements;
      },
      requirementProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchRequirements({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllRequirements(
              params
            )
              .then(response => {
                commit("SET_REQUIREMENTS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createRequirement({ commit }, requirement) {
          return new Promise((resolve, reject) => {
            createRequirement(requirement)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllRequirements({ commit }, requirements) {
          return new Promise((resolve, reject) => {
            createAllRequirements(requirements)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateRequirement({ commit }, requirement) {
          return new Promise((resolve, reject) => {
            updateRequirement(requirement)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteRequirement({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteRequirement(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_REQUIREMENTS(state, data) {
        state.requirements = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    